<template>
  <div>
    <business-header></business-header>
    <!-- side nav -->
    <div id="sideBar" class="columns">
      <aside
        :class="[{'is-narrow-desktop is-narrow-tablet': asideHide}, {'is-3-desktop is-4-tablet': !asideHide}, {'expand-div': expandDiv}]"
        class="left_column column is-2-fullhd is-2-widescreen hero is-fullheight is-hidden-mobile padding-left-0 padding-right-0"
        @click.self="showHideAside($event)">
        <nav class="menu">
          <!-- Side Menu Columns Begins -->
          <div v-for="item in menuItems" v-if="!item.isDivider && (!item.businessAdminOnly || can_invite) && item.permCode[permPos] && (!isFreeSubscription || item.showFree)"
               :class="[{ 'back-blue': item.isLink && matchesRoute(item.destination) }, { 'back-normal': !(item.isLink && matchesRoute(item.destination)) }, { 'parent-menu': !item.isLink && hasChildRoute(item.subMenu)|| (item.isParentMenu && isSubMenuActive)  }, {'is-hidden-touch is-hidden-mobile': item.hideOnMobile }, {'selected-menu': mainMenuContainsRoute(item)}, {'icon-as-image': false} ]"
               class="padding-top-bottom-6">
            <!-- menu item type isLink i.e it has no subMenu items -->
            <router-link v-if="item.isLink  && !item.mobileOnly && item.text !== 'Invite User'"
                         :class="['menu-label']"
                         :to="`${item.destination}`"
                         class="side-menu-nav-items has-text-centered" @click.native="collapseOthers">
              <img v-if="item.useIconAsImage" :alt="item.name" :class="item.imgClass" :src="item.icon"
                   :srcset="item.iconSet"/>
              <span :class="[{'is-hidden-tablet-only is-hidden-desktop-only': asideHide}]" class="nav_item_li"
                    v-text="item.text"></span>
            </router-link>
            <!-- hack for invite user -->
            <a v-if="item.isLink  && !item.mobileOnly && item.text === 'Invite User'"
               :class="['menu-label']"
               :to="`${item.destination}`"
               class="side-menu-nav-items has-text-centered" @click.prevent="item.destination">
              <img v-if="item.useIconAsImage" :alt="item.name" :class="item.imgClass" :src="item.icon"
                   :srcset="item.iconSet"/>
              <span :class="[{'is-hidden-tablet-only is-hidden-desktop-only': asideHide}]" class="nav_item_li"
                    v-text="item.text"></span>
            </a>
            <!-- menu item type isLink is false i.e it has subMenu items -->
            <p v-if="!item.isLink && !item.mobileOnly"
               class="menu-label has-icons-left has-icons-right side-menu-nav-items has-text-centered"
               @click="showHideChildren(item)">
              <img v-if="item.useIconAsImage" :alt="item.name" :class="item.imgClass" :src="item.icon"
                   :srcset="item.iconSet"/>
              <!-- <span class="icon is-left is-large"> -->
              <!-- <i :class="['fas', item.icon]" v-if="!item.useIconAsImage"></i> -->
              <!-- <img :src="item.icon" alt="icon" v-if="item.useIconAsImage"> -->
              <!-- </span> -->
              <span :class="[{'is-hidden-tablet-only is-hidden-desktop-only': asideHide}]" class="nav_item_li" href="#"
                    v-text="item.text"></span>
              <!-- <span :class="[{'is-hidden-tablet-only is-hidden-desktop-only': asideHide}, 'icon is-pulled-right is-large']"> -->
              <!-- <i :class="['fas', { 'fa-minus': item.showChildren }, { 'fa-plus': !item.showChildren }]"></i>-->
              <!-- </span> -->
            </p>
            <!-- menu item type isLink is false i.e it has subMenu items. Loop through each subMenu item and render list element -->
            <!-- <ul v-if="!item.isLink && !item.mobileOnly"
                :class="[{'is-hidden-tablet-only is-hidden-desktop-only': asideHide}, 'menu-list']">
                <li v-for="subItem in item.subMenu" v-if="item.showChildren && subItem.permCode[permPos]">
                    <router-link :to="`${subItem.destination}`"
                                 :class="[{'is-hidden-tablet-only is-hidden-desktop-only': asideHide},{'router-link-exact-active router-link-active': subItem.isSubMenuActive && isSubMenuActive}]"
                                 @click.native="collapseOthers">
                        <span class="icon is-left is-large"><i class="fas fa-plus"></i></span>
                        <span class="nav_item_li" v-text="subItem.text"></span>
                    </router-link>
                </li>
            </ul>-->
            <hr v-if="item.borderBottom" class="line-divider"/>
          </div> <!-- Side Menu Columns Ends -->
          <!-- <div class="admin_portal"> -->
          <!--   <ul v-if="is_hp_admin"> -->
          <!--     <li :class="[{'active_tab': is_admin_menu_active}]" @click="is_admin_menu_active ? '' : switchScreen()"><a class="is-hidden-mobile" href="javascript:void(0)">Admin</a></li> -->
          <!--     <li :class="[{'active_tab': !is_admin_menu_active}]" @click="!is_admin_menu_active ? '' : switchScreen()"><a class="is-hidden-mobile" href="javascript:void(0)">Portal</a></li> -->
          <!--   </ul> -->
          <!--  </div>  -->
          <div v-if="is_hp_admin" class="tabs is-toggle is-centered admin-portal-tabs">
            <ul>
              <li :class="[{'is-active': is_admin_menu_active}]" @click="is_admin_menu_active ? '' : switchScreen()"><a
                class="is-hidden-mobile" href="javascript:void(0)">Admin</a></li>
              <li :class="[{'is-active': !is_admin_menu_active}]" @click="!is_admin_menu_active ? '' : switchScreen()">
                <a class="is-hidden-mobile" href="javascript:void(0)">Portal</a></li>
            </ul>
          </div>
          <button class="upgrade-btn" data-track="upgrade plan from menu portal home" @click="upgradePlan">Upgrade&nbsp;Plan</button>
          <img class="menu-logo" src="/static/img/new/menu/logo.png"
               srcset="/static/img/new/menu/logo@2x.png 1.5x, /static/img/new/menu/logo@2x.png 2x, /static/img/new/menu/logo@3x.png 3x"/>
          <!-- <div class="is-hoverable switch-board-link" v-if="is_hp_admin"><a class="is-hidden-mobile" href="javascript:void(0)" @click="switchScreen">{{ getSwitchScreenLink }}</a></div> -->
          <!--   <!-- loop through each menu item -->
          <!--   <div class="padding-top-bottom-6 mobile-profile-switcher-menu-item" :class="[{'no-dropdown-icon':!hasMultipleBusinessRoles}, { 'display-submenu': switchMenuStatus}, ]" v-if="!is_admin_menu_active"> -->
          <!--     <p class="menu-label has-icons-left has-icons-right" @click="switchMenuStatus=!switchMenuStatus"> -->
          <!--       <span class="icon is-left is-large"><img :src="org_logo" /></span> -->
          <!--       <span href="#" class="profiler_name"  > {{ org_name }}</span> -->
          <!--     </p> -->
          <!--     <ul v-if="hasMultipleBusinessRoles" class="profiler_dropdown"> -->
          <!--       <li v-for="(business, index) in businessList"> -->
          <!--         <a class="business-link-item menu-label" :class="[{'active':business.selected}]" @click.prevent="switchProfile(business)"><span class="icon is-left is-large"><img :src="business.image"></span><span class="bussiness_name">{{ business.name }}</span> </a> -->
          <!--       </li> -->
          <!--     </ul> -->
          <!--   </div>  -->
        </nav>
        <!-- Slide Out Menu Begins -->
        <transition name="slide-fade">
          <nav v-if="menu.slideMenu.show" class="menu slide-out">
            <!-- Side Menu Columns Begins -->
            <!-- Various Menu and Submenu Begins -->
            <div v-if="!menuObj.slideMultiMenu" :key="menuObj.text" class="menu-items-section">
              <label class="padding-10 labeled-text">{{ menuObj.slideMenuTitle || menuObj.text }}</label>
              <div v-for="menuItem in menuObj.subMenu"
                   v-if="(showToAdminOnly(menuItem) && menuItem.isAdminActive) || menuItem.showAlways"
                   class="columns is-block padding-left-0 labeled-submenu">
                <router-link :to="menuItem.destination">
                  <div :class="[{'selected-menu': ('routeName' in menuItem &&  $route.name === menuItem.routeName) || (menuItem.destination === relevantPath())}]" class="column">
                    {{ menuItem.text }}
                  </div>
                </router-link>
              </div>
            </div>
            <div v-for="(multiMenu, title) in menuObj.slideMultiMenu" v-else :key="menuObj.text"
                 class="menu-items-section">
              <label class="padding-10 labeled-text">{{ title }}</label>
              <div v-for="(menuItem, linkTitle) in multiMenu" class="columns is-block padding-left-0 labeled-submenu">
                <router-link :to="menuItem.path">
                  <div :class="[{'selected-menu': (menuItem.path === relevantPath())}]" class="column">{{ linkTitle }}
                  </div>
                </router-link>
              </div>
            </div> <!-- Various Menu and Submenu Ends -->
          </nav> <!-- Slide Out Menu Ends -->
        </transition>
      </aside>
      <main
        :class="['column', 'main-column', {'new-background': newBackground}, {'is-padding-top-0': isPaddingTopZero}, {'is-full-width-view': isFullWidthView}]"
        @click="showSlideModal(false)">
        <modal></modal>
        <div :class="[{'is-padding-top-0': isPaddingTopZero}, {'is-full-width-view': isFullWidthView}]"
             class="column main-column">
          <exception-message></exception-message>
          <flash-message></flash-message>
        </div>
        <router-view><!-- component's template --></router-view>
      </main>
    </div>


    <!-- Review Invite Modal -->
    <div :class="['modal', 'new-modal', { 'is-active': showCollectModal }]">
      <div class="modal-background"></div>
      <div class="modal-card smaller">
        <header class="modal-card-head">
          <p class="modal-card-title">Ask For Reviews</p>
          <button aria-label="close" class="delete" @click.prevent="showCollectModal = false"></button>
        </header>
        <section class="modal-card-body">
          <div class="tabs">
            <ul>
              <li :class="{ 'is-active': isWhatsAppActive }" @click.prevent="isWhatsAppActive = true"><a>WhatsApp</a>
              </li>
              <li :class="{ 'is-active': !isWhatsAppActive }" @click.prevent="isWhatsAppActive = false"><a>Email&nbsp;&amp;&nbsp;SMS</a>
              </li>
            </ul>
          </div>
          <div v-show="isWhatsAppActive" class="tab-body is-marginless is-paddingless">
            <p class="has-text-centered section-header">Send a WhatsApp link to customers<br/>so that they can review
              you in two ticks.</p>
            <input v-model="whatsapp_mobile" autocomplete="off" class="sidebar-input input-ask-for-reviews mt45 mb15"
                   name="whatsapp_mobile" placeholder="Add mobile number" type="text"/>
            <button
              :class="['button solid-btn', 'ask-for-reviews', 'has-text-centered', { 'is-loading' : is_sending }]"
              data-track="sms whatsapp invite portal home"
              @click.prevent="smsWhatsappInvite">SMS&nbsp;the&nbsp;link
            </button>
            <div class="level is-mobile mt30">
              <div class="level-item">
                <div class="hr-line"></div>
              </div>
              <div class="level-item">
                <div class="hr-text"><p class="has-text-centered">OR</p></div>
              </div>
              <div class="level-item">
                <div class="hr-line"></div>
              </div>
            </div>
            <img alt="Copy Link" class="copy-img" src="/static/img/new/home/copy@2x.png"
                 srcset="/static/img/new/home/copy@2x.png 1.5x, /static/img/new/home/copy@2x.png 2x, /static/img/new/home/copy@3x.png 3x"/>
            <button class="button hollow-btn copy-btn" data-track="copy whatsapp link portal home modal" @click="copyLink">
              Copy&nbsp;Link
            </button>
          </div>
          <div v-show="!isWhatsAppActive" class="tab-body is-marginless is-paddingless">
            <p class="section-header width236-center"><span
              class="sub-section">Your last saved template will be used</span><br/>Send a once-off review invite in a
              flash.</p>
            <input v-model="invite_name" :disabled="is_sending" autocomplete="off"
                   class="sidebar-input input-ask-for-reviews"
                   name="invite_name"
                   placeholder="Name" type="text"/>
            <input v-model="invite_email" :disabled="is_sending" autocomplete="off"
                   class="sidebar-input input-ask-for-reviews mt10"
                   name="invite_email" placeholder="Email address" type="text"/>
            <div class="error">{{ invite_error }}</div>
            <p class="section-header width187-center"><span
              class="sub-section">Enter customer's mobile number</span><br/>Send a Quick SMS review invite</p>
            <input v-model="invite_mobile" :disabled="is_sending" autocomplete="off"
                   class="sidebar-input input-ask-for-reviews"
                   name="invite_mobile"
                   placeholder="Mobile number" type="text"/>
            <p class="color-58595b font-size-12 has-text-centered font-roboto margin-top-23 margin-bottom-2">Pressing send means you agree to our <a class="blue-link" href="https://www.hellopeter.com/legal/legal#section6" target="_blank">T&C’s</a>.
            </p>
            <button :class="['button solid-btn', 'ask-for-reviews', 'margin-bottom-7', { 'is-loading' : is_sending }]"
                    :disabled="!singleInviteDetailAdded || is_sending"
                    data-track="send email invite portal home" @click.prevent="sendSingleInvite">Send&nbsp;invite
            </button>
            <p class="has-text-centered is-hidden-mobile"><a class="send-multiple-invites"
                                                             data-track="I want to send multiple invites"
                                                             href="/collect-reviews/email-and-sms">I want to send
              multiple invites</a></p>
            <div class="hr-line-full"></div>
            <p class="footer-copy">Note: Even though two invites are sent to one customer, only one review invite credit
              will be deducted.</p>
          </div>
        </section>
      </div>
    </div>
    <!-- End Review Invite Modal -->
    <!-- User Invite Modal -->
    <div :class="['modal', 'new-modal', { 'is-active': showInviteModal }]">
      <div class="modal-background"></div>
      <div class="modal-card">
        <header class="modal-card-head">
          <p class="modal-card-title">Invite a new user</p>
          <button aria-label="close" class="delete" @click.prevent="showInviteModal = false"></button>
        </header>
        <section class="modal-card-body">
          <p>Enter the details of the user you would like to add to Hellopeter.</p>
          <input v-model="user_invite_email_address" autocomplete="off" class="is-fullwidth"
                 name="invite_contact_address"
                 placeholder="Email address" type="text"/>
          <p class="form-label">User&nbsp;role</p>
          <div class="control">
            <label class="radio">
              <input v-model="user_role" name="user_role" type="radio" value="3"/>
              <span class="radio-label">User</span><span
              class="description">&nbsp;-&nbsp;Can&nbsp;manage&nbsp;reviews</span>
            </label>
          </div>
          <div class="control">
            <label class="radio">
              <input v-model="user_role" name="user_role" type="radio" value="2"/>
              <span class="radio-label">Admin</span><span
              class="description">&nbsp;-&nbsp;Has&nbsp;full&nbsp;access</span>
            </label>
          </div>
        </section>
        <footer class="modal-card-foot">
          <button :class="['button', 'invite-btn', { 'is-loading' : is_sending }]" @click.prevent="sendInvite">Invite&nbsp;User</button>
        </footer>
      </div>
    </div>
    <!-- End User Invite Modal -->
  </div>
</template>
<script>
/* eslint-disable indent,no-new,no-undef,no-unused-vars, valid-jsdoc */
import _ from 'lodash'
import BusinessHeader from './Header.vue'
import FlashMessage from '../components/FlashMessage'
import ExceptionMessage from '../components/ExceptionMessage'
import Modal from '../components/Modal'
import MenuItems from './../mixins/menu.js'
import misc from '@/mixins/misc.js'
import axios from 'axios'
import {mapState, mapActions} from 'vuex'
import {SHOW_SLIDE_MENU} from '@/store/action.types'

export default {
  mixins: [MenuItems, misc],
  data () {
    return {
      is_sending: false,
      user_invite_email_address: '',
      whatsapp_mobile: '',
      showCollectModal: false,
      isWhatsAppActive: true,
      invite_name: '',
      invite_email: '',
      invite_error: '',
      invite_mobile: '',
      showInviteModal: false,
      newBackground: false,
      menuItemsNew: [],
      isSubMenuActive: false,
      asideHide: true,
      can_invite: JSON.parse(localStorage.getItem('can_invite')),
      is_ops: JSON.parse(localStorage.getItem('is_ops')),
      is_hp_admin: JSON.parse(localStorage.getItem('is_hp_admin')),
      is_admin_active: JSON.parse(localStorage.getItem('is_hp_admin')),
      is_admin_menu_active: JSON.parse(localStorage.getItem('is_admin_menu_active')),
      currentBusiness: JSON.parse(localStorage.getItem('org_industry_id')),
      selectedBusiness: '',
      expandDiv: false,
      org_logo: localStorage.getItem('org_logo') === 'null' ? localStorage.getItem('industry_icon') : localStorage.getItem('org_logo'),
      org_name: '',
      businessList: [],
      switchMenuStatus: false,
      menuObj: {},
      user_role: '3'
    }
  },
  components: {
    BusinessHeader,
    FlashMessage,
    ExceptionMessage,
    Modal
  },
  computed: {
    ...mapState({
      menu: state => state.app.menu
    }),
    /**
     * Check if Single Invite Data Added Correctly
     * @return {void}
     */
    singleInviteDetailAdded () {
      return this.invite_name && this.verifyEmail(this.invite_email)
    },
    whatsAppInviteURL () {
      const n = localStorage.getItem('org_name')
      return `https://wa.me/27212066516?text=${encodeURIComponent('To start writing a review about ')}${encodeURIComponent(n)}${encodeURIComponent(' TAP THE SEND ARROW')}`
    },
    getSwitchScreenLink () {
      return this.is_admin_active
    },
    hasMultipleBusinessRoles () {
      const roles = JSON.parse(localStorage.getItem('roles'))
      if (typeof roles === 'undefined' || roles === null) {
        this.$router.push('/login')
      } else {
        return roles.length > 1
      }
    },
    isPaddingTopZero () {
      return this.noPaddingTop.includes(this.$route.name)
    },
    /**
     * Check if page has full width view
     * @returns {Boolean}
     */
    isFullWidthView () {
      return this.fullWidthView.includes(this.$route.name)
    },
    /**
     * Check if page has full width view
     * @returns {Boolean}
     */
    isSlideMenuOpened () {
      let routeForMainMenu = false
      if (this.menuObj.slideMultiMenu) {
        _.map(this.menuObj.slideMultiMenu, (obj) => {
          _.map(obj, (internalObj) => {
            if (internalObj.path === this.$route.path) {
              routeForMainMenu = true
            }
          })
        })
      }
      if (this.menuObj.subMenu) {
        _.map(this.menuObj.subMenu, (obj) => {
          if (obj.destination === this.$route.path) {
            routeForMainMenu = true
          }
        })
      }
      return this.expandDiv && routeForMainMenu
    }
  },
  methods: {
    ...mapActions({
      showSlideModal: `app/${SHOW_SLIDE_MENU}`
    }),
    copyLink () {
      let url = this.whatsAppInviteURL
      this.$copyText(url)
        .then(() => {
          flash(`Successfully copied your WhatsApp link to your clipboard`, 'is-success')
          dataLayer.push({
            'userMessage': {
              'messageType': 'success',
              'messageName': 'Successfully copied WhatsApp ShareLink to clipboard from home page',
              'displayedMessage': `Successfully copied '${this.whatsAppInviteURL}' to your clipboard`
            }
          })
        })
    },
    showInviteUserModal () {
      // this.showInviteModal = true
      this.$router.push('/users')
    },
    smsWhatsappInvite () {
      const slug = localStorage.getItem('org_slug')
      this.is_sending = true
      axios.post(`/${slug}/sms-whatsapp-link`, {
        mobile: this.whatsapp_mobile
      })
        .then(({data}) => {
          this.is_sending = false
          this.showCollectModal = false
          const msg = `We've sent an SMS with your Business' WhatsApp link to ${this.whatsapp_mobile}`
          this.whatsapp_mobile = ''
          flash(msg)
          dataLayer.push({
            'userMessage': {
              'messageType': 'success',
              'messageName': 'Successfully sent an SMS with Business WhatsApp link',
              'displayedMessage': data
            }
          })
        })
        .catch((err) => {
          this.is_sending = false
          let msg = 'Unknown error'
          if (typeof err.response.data.errors !== 'undefined' && typeof err.response.data.errors.mobile !== 'undefined') {
            msg = err.response.data.errors.mobile[0]
          }
          this.is_sending = false
          flash(msg, 'is-danger')
          dataLayer.push({
            'userMessage': {
              'messageType': 'error',
              'messageName': 'Failed to SMS WhatsApp Link to provided mobile number',
              'displayedMessage': msg
            }
          })
        })
      // showCollectModal = false
    },
    sendSingleInvite () {
      this.is_sending = true
      this.invite_error = ''

      const businessId = localStorage.getItem('org_id')
      const slug = localStorage.getItem('org_slug')
      axios.post(`/${businessId}/review-invites/send-invite`, {
        bizSlug: slug,
        firstName: this.invite_name,
        email: this.invite_email,
        number: this.invite_mobile
      })
        .then(({data}) => {
          this.invite_name = this.invite_email = this.invite_mobile = ''

          if (data.sent) {
            this.displaySuccessMsg(`Review invitation successfully sent.`, 'Successfully sent review invitation')
          } else {
            this.displayErrMsg(error, 'Failed sending Review Invitation on Homepage', `Failed to send review invitation`)
          }
        })
        .catch((error) => {
          console.log('error.response.data', error.response.data)
          if (typeof error.response.data.error === 'string' || error.response.data.error instanceof String) {
            this.invite_error = error.response.data.error
          } else {
            Object.keys(error.response.data.errors).map((key) => {
              flash(error.response.data.errors[key][0], 'is-danger')
            })
          }
        })
        .finally(_ => {
          this.is_sending = false
        })
    },
    sendInvite () {
      this.is_sending = true
      const orgId = localStorage.getItem('org_id')
      axios.post(`/auth/create-invite`, {
        email: this.user_invite_email_address,
        role_id: this.user_role,
        org_id: orgId
      })
        .then(({data}) => {
          this.is_sending = false
          flash(data)
          dataLayer.push({
            'userMessage': {
              'messageType': 'success',
              'messageName': 'Successfully invited user on Invite Business User New Modal',
              'displayedMessage': data
            }
          })
          this.showInviteModal = false
          this.$router.push('/users')
        })
        .catch((err) => {
          let msg = ''
          if (typeof err.response.data.error !== 'undefined') {
            msg = err.response.data.error
          } else if (typeof err.response.data.errors !== 'undefined' && typeof err.response.data.errors.email !== 'undefined') {
            msg = err.response.data.errors.email[0]
          }
          this.is_sending = false
          flash(msg, 'is-danger')
          dataLayer.push({
            'userMessage': {
              'messageType': 'error',
              'messageName': 'Failed to invite user on Invite Business User View',
              'displayedMessage': msg
            }
          })
        })
    },
    launchCollectModal () {
      this.showCollectModal = true
    },
    setNewBackgroundColor () {
      this.newBackground = true
    },
    unsetNewBackgrounColor () {
      this.newBackground = false
    },
    getOrgName () {
      let name = localStorage.getItem('org_name')
      if (name.length > 50) {
        name = name.substring(0, 50) + '...'
      }
      this.org_name = name
    },
    showBusinessProfileSwitcher () {
      const roles = JSON.parse(localStorage.getItem('roles'))
      const currentOrg = parseInt(localStorage.getItem('org_id'))
      let businessList = []

      for (let i = 0; i < roles.length; i++) {
        businessList.push({
          id: roles[i]['org_id'],
          name: roles[i]['org_name'],
          image: roles[i]['org_logo'] ? roles[i]['org_logo'] : '/static/' + roles[i]['industry_icon'],
          selected: currentOrg === roles[i]['org_id']
        })
      }

      let options = {
        'title': 'Switch business profile',
        'body': '',
        'btn_action_title': 'SWITCH PROFILE',
        'show_btns': true,
        'task': 'switchProfile',
        'producer': {},
        'radioOptions': businessList
      }
      modal(options)
    },
    switchProfile (props) {
      let promises = []
      if (props.id) {
        const currentOrg = parseInt(localStorage.getItem('org_id'))
        if (currentOrg !== props.id) {
          const roles = JSON.parse(localStorage.getItem('roles'))
          for (let i = 0; i < roles.length; i++) {
            if (roles[i]['org_id'] === props.id) {
              promises.push(new Promise((resolve, reject) => {
                localStorage.removeItem('bizSources')
                localStorage.setItem('org_id', roles[i]['org_id'])
                localStorage.setItem('org_name', roles[i]['org_name'])
                localStorage.setItem('org_logo', roles[i]['org_logo'])
                localStorage.setItem('org_slug', roles[i]['org_slug'])
                localStorage.setItem('org_industry_id', roles[i]['org_industry_id'])
                localStorage.setItem('can_invite', JSON.stringify(roles[i]['role_slug'] === 'business-admin'))
                localStorage.setItem('industry_icon', '/static/' + roles[i]['industry_icon'])
                localStorage.setItem('org_join_date', roles[i]['org_join_date'])
                localStorage.setItem('role', roles[i]['role'])
                localStorage.setItem('org_reviews', JSON.stringify(roles[i]['org_reviews']))
                this.canBusinessAddUsers(roles[i]['org_id'])
                  .then(() => {
                    axios.get(`/${roles[i]['org_slug']}/billing-details`)
                      .then(({data}) => {
                        localStorage.setItem('billingDetails', JSON.stringify(data))
                        resolve()
                      })
                  })
              }))
            }
          }
        }
        if (promises.length > 0) {
          Promise.all(promises)
            .then(() => {
              this.is_admin_active = false
              localStorage.setItem('is_admin_menu_active', this.is_admin_active)
              if (this.$route.path === '/') {
                window.events.$emit('update-review-dashboard')
                setTimeout(() => {
                  location.reload()
                }, 400)
              } else {
                window.location.href = '/'
              }
            })
        }
      }
    },
    async canBusinessAddUsers (orgId) {
      try {
        let canBusinessAddUsers = await axios(`/auth/can-add-more-business-users/${orgId}`)
        localStorage.setItem('can_add_more_users', JSON.parse(canBusinessAddUsers.data.can_add_more_users))
      } catch (error) {
        flash('An unexpected error occurred. Please try again later.', 'is-danger')
      }
      window.events.$emit('businessLogoChanged')
    },
    switchScreen () {
      this.is_admin_active = !JSON.parse(localStorage.getItem('is_admin_menu_active'))
      localStorage.setItem('is_admin_menu_active', this.is_admin_active)
      this.is_admin_menu_active = JSON.parse(localStorage.getItem('is_admin_menu_active'))
      window.events.$emit('changeMenuList', this.is_admin_active)
      window.events.$emit('updateUsageMetrix', this.is_admin_menu_active)
      if (this.is_admin_active) {
        this.$router.push('/reviews-listing')
      } else {
        this.$router.push('/')
      }
    },
    changeSubmenu () {
      if (this.$router.currentRoute.name === 'ReviewInviteHistory') {
        this.isSubMenuActive = true
      } else {
        this.isSubMenuActive = false
      }
    },
    changeMenuList (status) {
      this.is_admin_menu_active = JSON.parse(localStorage.getItem('is_admin_menu_active'))

      this.menuItems = this.menuItems.map(data => {
        if (data.subMenu) {
          data.subMenu = data.subMenu.map(item => {
            item.isAdminActive = !item.isAdminActive
            return item
          })
        }
        data.isAdminActive = !data.isAdminActive
        return data
      })
      localStorage.setItem('admin', JSON.stringify({
        ...JSON.parse(localStorage.getItem('admin')),
        isLoadedFirstTime: status
      }))
    },
    showHPAdminOnlyMenu () {
      return (this.is_hp_admin)
    },
    getAllBusinesses () {
      const roles = JSON.parse(localStorage.getItem('roles'))
      const currentOrg = parseInt(localStorage.getItem('org_id'))
      for (let i = 0; i < roles.length; i++) {
        this.businessList.push({
          id: roles[i]['org_id'],
          name: roles[i]['org_name'],
          image: roles[i]['org_logo'] ? roles[i]['org_logo'] : '/static/' + roles[i]['industry_icon'],
          selected: currentOrg === roles[i]['org_id']
        })
      }
    },
    showOtherAdminMenus (menuItem) {
      return (!this.is_hp_admin && menuItem.hpAdminOnly === undefined)
    },
    /**
     * Show to admin only
     * @param String  menuItem
     * @returns {Boolean}
     */
    showToAdminOnly (menuItem) {
      return this.is_hp_admin && (menuItem && menuItem.hpAdminOnly === true)
    },
    showOpsOnlyMenu (menuItem) {
      return (menuItem.opsOnly === undefined || !menuItem.opsOnly)
    },
    showHideAside (event) {
      const targetType = event.target.type

      if (typeof targetType === 'undefined') {
        this.asideHide = !this.asideHide
      }
    },
    /**
     * Show/Hide the Slider Menu
     * @returns {void}
     */
    showHideChildren (item) {
      this.menuObj = {}
      if (this.asideHide) {
        this.asideHide = false
      }
      item.showChildren = !item.showChildren
      this.expandDiv = item.showChildren
      Object.assign(this.menuObj, item)
      this.expandDiv ? this.showSlideModal() : this.showSlideModal(false)
    },
    matchesRoute (routePath) {
      return this.$route.path === routePath
    },
    hasChildRoute (item) {
      const routePath = this.$route.path

      for (let [index, value] of Object.entries(item)) {
        if (value.destination === routePath || routePath.indexOf(value.destination) !== -1) {
          return true
        }
      }
      return false
    },
    collapseOthers (ignore = null) {
      const currentRoute = this.$route.path
      this.expandDiv = false
      let subMenuHasActiveLink = (item) => {
        for (let [index, value] of Object.entries(item)) {
          if (value.destination === currentRoute) {
            return true
          }
        }
        return false
      }

      for (let [index, item] of Object.entries(this.menuItems)) {
        if (!item.mobileOnly && !item.isLink) {
          if (!subMenuHasActiveLink(item.subMenu)) {
            item.showChildren = false
          }
        }
      }
    },
    setBillingMenu (val) {
      let menu = {}
      if (val) {
        menu = {
          isLink: false, // is a router link
          destination: '', // router target
          text: 'Billing', // menu label to display
          mobileOnly: false, // whether or not this menu item should be rendered for Mobile
          // icon: 'fas far fa-money-bill-alt', // icon to render
          icon: '/static/img/new/menu/billing.png',
          iconSet: '/static/img/new/menu/billing@2x.png 1.5x, /static/img/new/menu/billing@2x.png 2x, /static/img/new/menu/billing@3x.png 3x',
          useIconAsImage: true,
          imgClass: 'billing-icon-img',
          isAdminActive: false,
          businessAdminOnly: true, // whether or not this menu item should be available to Business Admins only
          showChildren: false,
          permCode: [1, 0, 1, 0],
          subMenu: [
            {
              destination: '/billing',
              text: 'Billing Details',
              isAdminActive: false,
              permCode: [0, 0, 1, 0]
            },
            {
              destination: '/eft-manual-matching',
              text: 'EFT Manual Matching',
              isAdminActive: true,
              hpAdminOnly: true, // this menu item will only be available to HP hp admin
              permCode: [1, 0, 0, 0]
            },
            {
              destination: '/invoices',
              text: 'Invoices',
              isAdminActive: true,
              hpAdminOnly: true, // this menu item will only be available to HP hp admin
              permCode: [1, 0, 0, 0]
            }
          ]
        }
        // this.menuItems[15] = menu
      } else {
        menu = {
          isLink: true, // is a router link
          destination: '/billing', // router target
          text: 'Billing', // menu label to display
          mobileOnly: false, // whether or not this menu item should be rendered for Mobile
          // icon: 'fas far fa-money-bill-alt', // icon to render
          icon: '/static/img/new/menu/billing.png',
          iconSet: '/static/img/new/menu/billing@2x.png 1.5x, /static/img/new/menu/billing@2x.png 2x, /static/img/new/menu/billing@3x.png 3x',
          useIconAsImage: true,
          imgClass: 'billing-icon-img',
          isAdminActive: false,
          businessAdminOnly: true, // whether or not this menu item should be available to Business Admins only
          permCode: [0, 0, 1, 0]
        }
        // this.menuItems[15] = menu // (07/05/21) Uncomment it if Vikas added the New Review Mangmnt. and Side Menu breaks for billing
      }
      this.menuItems.forEach((item, index) => {
        if (index === 15) {
          this.menuItemsNew.push(menu)
        } else {
          this.menuItemsNew.push(item)
        }
      })
    },
    /**
     * Close all the Submenu items
     * @returns {void}
     */
    closeAllSubMenu () {
      this.menuItems.forEach((item) => {
        item.showChildren = false
      })
    },
    /**
     * Check if main menu contains the current to show it active
     * @returns {Boolean}
     */
    mainMenuContainsRoute (menuItems) {
      let routeForMainMenu = false
      if (menuItems.slideMultiMenu) {
        _.map(menuItems.slideMultiMenu, (obj) => {
          _.map(obj, (internalObj) => {
            if (internalObj.path === this.$route.path) {
              routeForMainMenu = true
            }
          })
        })
      }
      if (menuItems.subMenu) {
        _.map(menuItems.subMenu, (obj) => {
          if (obj.destination === this.$route.path) {
            routeForMainMenu = true
          }
        })
      }
      return routeForMainMenu
    },
    /**
     * Create a relevant path with added Query Strings
     * @returns {string}
     */
    relevantPath () {
      let queryString = ''
      if (this.$route.query) {
        Object.entries(this.$route.query).forEach((val, key) => {
          queryString += `${val[0]}=${val[1]}` + (key < Object.entries(this.$route.query).length - 1 ? '&' : '')
        })
      }
      return `${this.$route.path}${queryString ? `?` + queryString : ''}`
    }
  },
  mounted () {
    this.setBillingMenu(this.is_hp_admin)
  },
  created () {
    window.events.$on('show-invite-modal', () => {
      this.showInviteUserModal()
    })
    window.events.$on('launchCollectModal', () => {
      this.launchCollectModal()
    })
    window.events.$on('changeMenuList', this.changeMenuList)
    this.changeSubmenu()
    window.events.$on('switchProfile', this.switchProfile)
    window.events.$on('setNewBackground', this.setNewBackgroundColor)
    window.events.$on('unsetNewBackground', this.unsetNewBackgrounColor)
    this.getAllBusinesses()
    this.getOrgName()
  },
  destroyed () {
    window.events.$off('changeMenuList', this.changeMenuList)
    window.events.$off('switchProfile', this.switchProfile)
    window.events.$off('setNewBackground', this.setNewBackgroundColor)
    window.events.$off('unsetNewBackground', this.unsetNewBackgrounColor)
    window.events.$off('launchCollectModal')
    window.events.$off('show-invite-modal')
  },
  watch: {
    '$route' (to, from) {
      this.changeSubmenu()
      this.closeAllSubMenu()
      this.expandDiv = this.showSlideModal(false)
    }
  }
}
</script>
<style scoped>
.error {
  color: #E8441F;
  font-size: 12px;
  text-align: center;
}

.tabs {
  margin-bottom: 19px;
}

.hr-line-full {
  margin-top: 10px;
}

.width236-center {
  margin-bottom: 9px;
}

.width187-center {
  margin-bottom: 10px;
  margin-top: 19px;
}
</style>
<style>
.home-icon-img {
  display: block;
  width: 19px;
  height: 19px;
  margin: 0 auto;
}

.reply-icon-img {
  display: block;
  width: 25px;
  height: 20px;
  margin: 0 auto;
}


.collect-icon-img {
  display: block;
  width: 17px;
  height: 17px;
  margin: 0 auto;
}

.share-icon-img {
  display: block;
  width: 17px;
  height: 16px;
  margin: 0 auto;
}

.insights-icon-img {
  display: block;
  width: 23px;
  height: 18px;
  margin: 0 auto;
}

.billing-icon-img {
  display: block;
  width: 14px;
  height: 18px;
  margin: 0 auto;
}

.integration-icon-img {
  display: block;
  width: 20px;
  height: 24px;
  margin: 0 auto;
}

.business-settings-icon-img {
  display: block;
  width: 25px;
  height: 25px;
  margin: 0 auto;
}

.invite-user-icon-img {
  display: block;
  width: 27px;
  height: 22px;
  margin: 0 auto;
}

.all-reviews-icon-img {
  display: block;
  width: 20px;
  height: 17px;
  margin: 0 auto;
}

.sweep-icon-img {
  display: block;
  width: 17px;
  height: 15px;
  margin: 0 auto;
}

.spam-icon-img {
  display: block;
  width: 17px;
  height: 15px;
  margin: 0 auto;
}

.reported-icon-img {
  display: block;
  width: 14px;
  height: 18px;
  margin: 0 auto;
}

.businesses-icon-img {
  display: block;
  width: 17px;
  height: 16px;
  margin: 0 auto;
}

.verification-icon-img {
  display: block;
  width: 15px;
  height: 15px;
  margin: 0 auto;
}

.profile-manage-icon-img {
  display: block;
  width: 17px;
  height: 17px;
  margin: 0 auto;
}

.users-icon-img {
  display: block;
  width: 17px;
  height: 15px;
  margin: 0 auto;
}

.new-background {
  background-color: #f6f6f6;
  padding: 0 !important;
}

.new-background > .column.main-column {
  padding: 0 !important;
}

input {
  color: #58595b;
}

.menu {
  cursor: pointer;
}

/* optional styles, I'm using this for centering radiobuttons */
.flex {
  display: flex;
  align-items: center;
}

.input, .textarea, .button {
  border-radius: 0;
  box-shadow: none;
  -webkit-box-shadow: none;
}

.column-checkbox {
  padding-top: 10px !important;
  padding-left: 0 !important;
  padding-right: 10px !important;
}

.columns {
  margin: 0;
}

.divider {
  border-bottom: 1px solid #dbdbdb;
  margin-bottom: 25px !important;
  padding-bottom: 3px !important;
}

figure img {
  border-radius: 50%;
}

aside {
  background-color: #565e65;
  padding: 0 !important;
  width: 115px;
}

main {
  padding-left: 20px !important;
  padding-right: 20px !important;
}

#sideBar {
  margin-top: 0;
}

.line-divider {
  margin-left: -8px;
  margin-top: 0px;
  margin-bottom: 0px;
  margin-right: 15px;
}

.mobile-profile-switcher-menu-item::after {
  -webkit-transform: rotate(45deg);
  transform: rotate(-45deg);
}

.mobile-profile-switcher-menu-item.display-submenu::after {
  -webkit-transform: rotate(136deg);
  transform: rotate(136deg);
  margin-top: -2px;
}

.mobile-profile-switcher-menu-item.display-submenu ul.profiler_dropdown {
  display: block;
}

.left_column .menu-list .router-link-active:before {
  content: '';
  width: 3px;
  height: 100%;
  position: absolute;
  top: 0;
  background: #30aae1 !important;
}

.left_column .padding-top-bottom-6.back-normal .menu-list .router-link-active {
  border-left: 0px !important;
}

@media screen and (max-width: 1023px) {
  aside p, aside strong, aside a, .navbar-link {
    color: #ffffff !important;
  }

  aside.left_column .padding-top-bottom-6.is-hidden-touch {
    display: block !important;
  }

  .left_column .parent-menu p {
    padding-left: 12px !important;
  }
}

@media screen and (max-width: 1024px) {
  main {
    padding-left: 20px !important;
    padding-right: 20px !important;
  }

  aside {
    padding: 0 !important;
  }

  aside > .menu > p, aside > .menu > ul {
    padding-left: 12px;
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }

  .menu > p > .icon.is-left {
    border-left: 4px solid #2aabe1;
  }

}

@media screen and (max-width: 767px) {
  main {
    padding-left: 0px !important;
    padding-right: 0px !important;
  }

  .navbar-brand {
    padding-left: 0px !important;
  }


}

.navbar-item img {
  max-height: 2.3rem !important;
}

.menu-label, .menu-list a {
  font-size: .8em;
  color: #fff;
  padding: .65rem 1rem !important;
}

.menu-label {
  margin-top: 20px !important;
  font-weight: 500;
  text-transform: none;
  letter-spacing: 0.04rem;
  display: block;
}

.menu-list a:hover {
  background-color: #30AAE1;
  color: #ffffff;
}

.icon.is-small {
  display: block;
  float: right;
}

.back-blue .router-link-active {
  background-color: #30AAE1;
  color: #fff;
}

a.navbar-item:hover, a.navbar-item.is-active, a.navbar-link:hover, a.navbar-link.is-active {
  background-color: #565e65;
}

.hero.is-light a.navbar-item:hover, .hero.is-light a.navbar-item.is-active, .hero.is-light .navbar-link:hover, .hero.is-light .navbar-link.is-active {
  background-color: #565e65;
}

.column.has-vertically-aligned-content {
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.media > .media-content > .router-link-active {
  background-color: #565e65;
}

.media > .media-content > .router-link-exact-active {
  background-color: #30AAE1;
}

.menu > .media {
  margin-top: 0;
  color: #ffffff;
  font-size: 0.9rem;
}

.menu > .media + .media {
  border: none;
}

.menu > article.media + article.media {
  padding-top: 0;
}

.menu > .media > .media-content > a {
  color: #ffffff;
}

.menu > .media > .media-left {
  margin-right: 0;
  padding-left: 0.5rem;
}

.menu > .media > .media-content > .menu-list > li > a {
  font-size: 0.9rem;
  padding-left: 0;
}

.menu > div:not(.parent-menu) {
  border-left: 3px solid #565e65;
}

.menu > div > a:hover {
  color: #ffffff;
}

.menu > div > ul > li > a {
  border-radius: 0;
}

.back-blue {
  background-color: #30AAE1;
  border-left: 3px solid #30AAE1 !important;
}

.back-normal {
  border-left: 3px solid #fff !important;
}

.menu > div > ul.menu-list > li > a {
  margin: 0 !important;
}

.menu > div > .menu-label:not(:last-child) {
  margin: 0 !important;
}

.menu > div > .menu-label {
  margin: 0 !important;
  letter-spacing: 0.01px;
}

.parent-menu {
  background-color: #677179;
  border-left: 3px solid #30AAE1;
}

.menu > div > .menu-label > a, .parent-menu > .menu-label > a {
  color: #ffffff;
}

.menu > div > ul.menu-list > li > a > span.icon {
  color: rgba(0, 0, 0, 0);
}

.menu > article.media > .media-left {
  border-left: 3px solid #565e65;
}

.menu > article.media.parent-menu > .media-left {
  background-color: #677179;
  border-left: 3px solid #30AAE1;
}

@media screen and (min-width: 1216px) {
  .icon.is-large {
    height: 2rem;
    width: 2rem;
  }
}

@media screen and (min-width: 1341px) {
  .icon.is-large {
    height: 3rem;
    width: 3rem;
  }
}

.tabs a {
  color: #6e757a;
}

.is-warning {
  color: #fff;
  background-color: #fb922c;
}

.is-warning-middle {
  background-color: #faddc1;
}

.menu > div > a.router-link-active:not(.router-link-exact-active) {
  background-color: transparent;
}

.border-0 {
  border: none !important;
}

.left_column .back-blue {
  background-color: rgba(103, 113, 122, 0.1);
  border-left: 3px solid #1261a0 !important;
  clear: both;
}

.left_column .menu-label, .left_column .menu-list a {
  font-size: .75em;
  color: #58595b;
  position: relative;
}

.left_column {
  background-color: #fff;
  border-right: 1px solid rgba(138, 140, 145, 0.32)
}

.left_column .back-blue .router-link-active {
  background-color: transparent;
  color: #30aae1;
}

.left_column .menu-label i {
  font-size: 16px;
}

.menu > div > a:hover, .menu > div > .menu-label:hover {
  color: #30aae1;
}

.left_column .menu-label .fa-minus, .left_column .menu-label .fa-plus {
  font-size: 12px;
}

.left_column .menu-list a:hover {
  background: transparent;
  color: #30aae1;
}

.left_column .parent-menu {
  background-color: transparent;
  border-left: 0px solid #30AAE1;
}

.left_column .menu-list .router-link-active {
  color: #30aae1 !important;
  background-color: rgba(103, 113, 122, 0.1);
  border-left: 3px solid #30aae1 !important;
}

.admin-portal-tabs {
  margin-top: 70px;
}

.admin-portal-tabs > ul > li > a {
  font-size: 11px;
  font-family: Roboto;
  padding: 0.25em 0.5em;
}

.upgrade-btn {
  background-color: #397ef5;
  color: #fff;
  text-align: center;
  font-family: Roboto;
  font-size: 12px;
  font-weight: 300;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.29;
  letter-spacing: normal;
  width: 93px;
  height: 24px;
  border: none;
  border-radius: 4px;
  margin: 16px auto 0 auto;
  display: block;
  cursor: pointer;
}

.tabs.is-toggle li.is-active a {
  background-color: #397ef5;
  border-color: #397ef5;
}

.menu-logo {
  display: block;
  width: 74px;
  height: 20px;
  margin: 25px auto 10px auto;
}

.admin_portal ul li {
  display: inline-block;
  width: 45px;
  height: 24px;
  border-bottom-left-radius: 4px;
  border-top-left-radius: 4px;
  text-align: center;
  color: #58595b !important;
  font-size: 11px;
  font-family: Roboto;
  line-height: 21px;
  border-left: 1px solid #d8d8d8;
  border-top: 1px solid #d8d8d8;
  border-bottom: 1px solid #d8d8d8;
  /* line-height: 24px; */
}

.admin_portal ul li:last-child {
  border: none;
  border-bottom-left-radius: 0px;
  border-top-left-radius: 0px;
  border-bottom-right-radius: 4px;
  border-top-right-radius: 4px;
  border-right: 1px solid #d8d8d8;
  border-top: 1px solid #d8d8d8;
  border-bottom: 1px solid #d8d8d8;
}

.admin_portal {
  width: 90%;
  border-left: 0px !important;
  margin: 80px auto 0 auto;
}

.hero.is-light a:not(.button):not(.dropdown-item):not(.tag) {
  color: #58595b !important;
}

header.hero.is-light nav.navbar.is-fixed-top-touch, header.hero.is-light {
  background-color: #fff !important;
}

div#navMenu .navbar-end.is-hidden-touch a {
  font-size: 0.7rem;
}

.hero.is-light .navbar-link:hover {
  background-color: transparent !important;
}

#navMenu .navbar-link {
  background: transparent;
}

#navMenu .navbar-link::after {
  border: solid 1px #58595b;
  border-right: 0;
  border-top: 0;
  content: " ";
  display: block;
  height: 0.6em;
  pointer-events: none;
  position: absolute;
  -webkit-transform: rotate(-45deg);
  transform: rotate(-45deg);
  -webkit-transform-origin: center;
  transform-origin: center;
  width: 0.6em;
  margin-top: -0.375em;
  right: 1.125em;
  top: 50%;
  z-index: 4;
}

.admin_portal li.active_tab {
  background: #397ef5;
  color: #fff;
  border-right: 0.5px solid #d3d3d3;
}

.admin_portal li.active_tab:first-child {
  border-right: none;
}

.admin_portal li.active_tab a {
  color: #fff;
}

.admin_portal ul li a {
  color: #58595b;
}

.mobile-profile-switcher-menu-item .has-icons-left .icon img {
  width: 30px;
  height: 30px;
  border-radius: 100%;
}

aside.left_column .mobile-profile-switcher-menu-item .has-icons-left .icon, a.business-link-item.menu-label .icon {
  width: 30px !important;
  height: 30px !important;
  float: left;
}

.mobile-profile-switcher-menu-item p.menu-label {
  font-size: 12px;
  font-weight: bold;
  text-transform: capitalize;

}

span.profiler_name {
  line-height: 30px;
  margin-left: 8px;
  width: 80%;
  display: inline-block;
}


ul.profiler_dropdown {
  position: absolute;
  background: #fff;
  width: 100%;
  z-index: 2;
  display: none;
  left: 0;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.16);
  border: solid 1px #f7f8f8;
  margin-top: 5px;
  border-left: 0px;
  border-radius: 0px;
}

ul.profiler_dropdown li {
  display: block;
  float: left;
  width: 100%;
}

.mobile-profile-switcher-menu-item.padding-top-bottom-6 {
  position: relative;
  padding: 5px 0px;
}

a.business-link-item.menu-label {
  margin: 0px !important;
  float: left;
  width: 100%;
  text-transform: capitalize;
  padding-left: 16px;
  letter-spacing: 0.01px;
}

a.business-link-item.menu-label span {
  line-height: 30px;
}

a.business-link-item.menu-label.active {
  background-color: rgba(103, 113, 122, 0.1);
  border-left: 3px solid #30aae1 !important;
  color: #30aae1;
}

a.business-link-item.menu-label:hover {
  color: #30aae1;
}

.menu > div:not(.parent-menu) {
  /* padding-left: 5px; */
}

a.business-link-item.menu-label .icon img {
  width: 16px;
  height: 16px;
  border-radius: 100%;
}

a.business-link-item.menu-label span.bussiness_name {
  width: 85%;
  float: left;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  padding-left: 1rem;
}

a.business-link-item.menu-label .icon {
  width: 14%;
}

.mobile-profile-switcher-menu-item:after {
  border: solid 1px #58595b;
  border-right: 0;
  border-top: 0;
  content: " ";
  display: block;
  height: 0.5em;
  pointer-events: none;
  position: absolute;
  -webkit-transform: rotate(-45deg);
  transform: rotate(-45deg);
  -webkit-transform-origin: center;
  transform-origin: center;
  width: 0.5em;
  margin-top: -0.375em;
  right: 0.65em;
  top: 50%;
  z-index: 4;
}

.menu > div:not(.parent-menu) {
  border-left: 0px solid #565e65;
}

.menu > div:not(.parent-menu) {
  /* padding-left: 12px; */
}

.admin_portal {
  padding-left: 0px !important;
}

.mobile-profile-switcher-menu-item.no-dropdown-icon:after {
  display: none;
}

.left_column .parent-menu p {
  padding-left: 12px !important;
}

.left_column .menu-label i.fas.fa-tachometer-alt, .navbar-start a.navbar-item .icon i.fas.fa-tachometer-alt {
  background: url('/static/img/imgh1.svg');
  width: 24px;
  height: 14px;
  background-repeat: no-repeat;
  background-position: center;
}

.left_column .menu-label i::before, .navbar-start a.navbar-item .icon i::before, .navbar-start a.navbar-link .icon i::before {
  visibility: hidden;
}

.navbar-start a.navbar-link .icon.is-small i::before {
  visibility: visible;
}

.padding-top-bottom-6:hover .menu-label i.fas.fa-tachometer-alt, .left_column .router-link-exact-active.menu-label i.fas.fa-tachometer-alt, .navbar-start a.navbar-item.router-link-exact-active .icon i.fas.fa-tachometer-alt {
  background: url('/static/img/img1.svg');
}

.left_column .menu-label i.fab.fa-google, .navbar-start a.navbar-item .icon i.fab.fa-google {
  background: url('/static/img/social/google/img2.svg');
  width: 19px;
  height: 19px;
  background-repeat: no-repeat;
  background-position: center;
}

.padding-top-bottom-6:hover .menu-label i.fab.fa-google, .left_column .router-link-exact-active.menu-label i.fab.fa-google, .navbar-start a.navbar-item.router-link-exact-active .icon i.fab.fa-google {
  background: url('/static/img/social/google/imgh2.svg');
}

.left_column .menu-label i.fas.fa-edit, .navbar-start a.navbar-item .icon i.fas.fa-edit {
  background: url('/static/img/icons/img3.svg');
  width: 25px;
  height: 19px;
  background-repeat: no-repeat;
  background-position: center;
}

.padding-top-bottom-6:hover .menu-label i.fas.fa-edit, .left_column .router-link-exact-active.menu-label i.fas.fa-edit, .navbar-start a.navbar-item.router-link-exact-active .icon i.fas.fa-edit {
  background: url('/static/img/icons/imgh3.svg');
}

.left_column .menu-label i.fas.fa.fa-shopping-basket, .navbar-start a.navbar-link .icon i.fa.fa-shopping-basket, .navbar-start a.navbar-item .icon i.fas.fa.fa-shopping-basket {
  background: url('/static/img/icons/img4.svg');
  width: 20px;
  height: 17px;
  background-repeat: no-repeat;
  background-position: center;
}

.padding-top-bottom-6:hover .menu-label i.fas.fa.fa-shopping-basket, .left_column .router-link-exact-active.menu-label i.fas.fa.fa-shopping-basket, .navbar-start a.navbar-item.router-link-exact-active .icon i.fas.fa.fa-shopping-basket {
  background: url('/static/img/imgh4.svg');
}

.left_column .menu-label i.fa.fa-window-restore, .navbar-start a.navbar-item .icon i.fa.fa-window-restore {
  background: url('/static/img/icons/img5.svg');
  width: 17px;
  height: 17px;
  background-repeat: no-repeat;
  background-position: center;
}

.padding-top-bottom-6:hover .menu-label i.fa.fa-window-restore, .left_column .router-link-exact-active.menu-label i.fa.fa-window-restore, .navbar-start a.navbar-item.router-link-exact-active .icon i.fa.fa-window-restore {
  background: url('/static/img/imgh5.svg');
}

.left_column .menu-label i.fab.fa-facebook, .navbar-start a.navbar-item .icon i.fab.fa-facebook {
  background: url('/static/img/icons/img6.svg');
  width: 17px;
  height: 20px;
  background-repeat: no-repeat;
  background-position: center;
}

.padding-top-bottom-6:hover .menu-label i.fab.fa-facebook, .left_column .router-link-exact-active.menu-label i.fab.fa-facebook, .navbar-start a.navbar-item.router-link-exact-active .icon i.fab.fa-facebook {
  background: url('/static/img/icons/icons/imgh6.svg');
}

.left_column .menu-label i.fas.fa-chart-bar, .navbar-start a.navbar-item .icon i.fas.fa-chart-bar {
  background: url('/static/img/icons/img7.svg');
  width: 22px;
  height: 18px;
  background-repeat: no-repeat;
  background-position: center;
}

.padding-top-bottom-6:hover .menu-label i.fas.fa-chart-bar, .left_column .router-link-exact-active.menu-label i.fas.fa-chart-bar, .navbar-start a.navbar-item.router-link-exact-active .icon i.fas.fa-chart-bar {
  background: url('/static/img/icons/imgh7.svg');
}

.left_column .menu-label i.fas.fa-suitcase, .navbar-start a.navbar-item .icon i.fas.fa-suitcase {
  background: url('/static/img/icons/img8.svg');
  width: 18px;
  height: 16px;
  background-repeat: no-repeat;
  background-position: center;
}

.padding-top-bottom-6:hover .menu-label i.fas.fa-suitcase, .left_column .router-link-exact-active.menu-label i.fas.fa-suitcase, .navbar-start a.navbar-item.router-link-exact-active .icon i.fas.fa-suitcase {
  background: url('/static/img/icons/imgh8.svg');
}

.left_column .menu-label i.fas.far.fa-money-bill-alt, .navbar-start a.navbar-item .icon i.fas.far.fa-money-bill-alt, .navbar-start a.navbar-link .icon i.far.fa-money-bill-alt {
  background: url('/static/img/icons/img9.svg');
  width: 13px;
  height: 18px;
  background-repeat: no-repeat;
  background-position: center;
}

.padding-top-bottom-6:hover .menu-label i.fas.far.fa-money-bill-alt, .left_column .router-link-exact-active.menu-label i.fas.far.fa-money-bill-alt {
  background: url('/static/img/imgh9.svg');
}

.left_column .menu-label i.fas.fa-user, .navbar-start a.navbar-item .icon i.fas.fa-user {
  background: url('/static/img/icons/img10.svg');
  width: 17px;
  height: 22px;
  background-repeat: no-repeat;
  background-position: center;
}

.padding-top-bottom-6:hover .menu-label i.fas.fa-user, .left_column .router-link-exact-active.menu-label i.fas.fa-user, .navbar-start a.navbar-item.router-link-exact-active .icon i.fas.fa-user {
  background: url('/static/img/imgh10.svg');
}

.left_column .menu-label .icon.is-pulled-right i::before {
  visibility: visible;
}

div#navMenu a.navbar-item i.fas.fa-trash {
  background: url('/static/img/img11.svg');
  width: 17px;
  height: 20px;
  background-repeat: no-repeat;
  background-position: center;
}

.padding-top-bottom-6:hover .menu-label i.fas.fa-trash, .left_column .router-link-exact-active.menu-label i.fas.fa-trash, div#navMenu a.navbar-item.router-link-active i.fas.fa-trash {
  background: url('/static/img/imgh11.svg');
}

.left_column .menu-label i.fas.fa-trash {
  background: url('/static/img/icons/img11.svg');
  width: 17px;
  height: 20px;
  background-repeat: no-repeat;
  background-position: center;
}

.left_column .menu-label i.fas.fa-recycle, .navbar-start a.navbar-item .icon i.fas.fa-recycle {
  background: url('/static/img/icons/img12.svg');
  width: 18px;
  height: 16px;
  background-repeat: no-repeat;
  background-position: center;
}

.padding-top-bottom-6:hover .menu-label i.fas.fa-recycle, .left_column .router-link-exact-active.menu-label i.fas.fa-recycle, .navbar-start a.navbar-item.router-link-exact-active .icon i.fas.fa-recycle {
  background: url('/static/img/imgh12.svg');
  width: 17px;
  height: 15px;
}

.left_column .menu-label i.fas.fa-exclamation-triangle, .navbar-start a.navbar-item .icon i.fas.fa-exclamation-triangle {
  background: url('/static/img/icons/img13.svg');
  width: 14px;
  height: 18px;
  background-repeat: no-repeat;
  background-position: center;
}

.padding-top-bottom-6:hover .menu-label i.fas.fa-exclamation-triangle, .left_column .router-link-exact-active.menu-label i.fas.fa-exclamation-triangle, .navbar-start a.navbar-item.router-link-exact-active .icon i.fas.fa-exclamation-triangle {
  background: url('/static/img/imgh13.svg');
}

.left_column .menu-label i.fas.fa-building, .navbar-start a.navbar-item .icon i.fas.fa-building {
  background: url('/static/img/icons/business-icon-grey.svg');
  width: 18px;
  height: 16px;
  background-repeat: no-repeat;
  background-position: center;
}

.padding-top-bottom-6:hover .menu-label i.fas.fa-building, .left_column .router-link-exact-active.menu-label i.fas.fa-building, .navbar-start a.navbar-item.router-link-exact-active .icon i.fas.fa-building {
  background: url('/static/img/business-icon-blue.svg');
}

.left_column .menu-label i.fas.fa-check, .navbar-start a.navbar-item .icon i.fas.fa-check {
  background: url('/static/img/icons/img14.svg');
  width: 15px;
  height: 15px;
  background-repeat: no-repeat;
  background-position: center;
}

.padding-top-bottom-6:hover .menu-label i.fas.fa-check, .left_column .router-link-exact-active.menu-label i.fas.fa-check, .navbar-start a.navbar-item.router-link-exact-active .icon i.fas.fa-check {
  background: url('/static/img/imgh14.svg');
}

.left_column .menu-label i.fas.fa-object-ungroup, .navbar-start a.navbar-item .icon i.fas.fa-object-ungroup {
  background: url('/static/img/icons/img15.svg');
  width: 17px;
  height: 17px;
  background-repeat: no-repeat;
  background-position: center;
}

.padding-top-bottom-6:hover .menu-label i.fas.fa-object-ungroup, .left_column .router-link-exact-active.menu-label i.fas.fa-object-ungroup, .navbar-start a.navbar-item.router-link-exact-active .icon i.fas.fa-object-ungroup {
  background: url('/static/img/imgh15.svg');
}

.left_column .menu-label i.fas.fa-users, .navbar-start a.navbar-item .icon i.fas.fa-users {
  background: url('/static/img/icons/img16.svg');
  width: 17px;
  height: 15px;
  background-repeat: no-repeat;
  background-position: center;
}

.padding-top-bottom-6:hover .menu-label i.fas.fa-users, .left_column .router-link-exact-active.menu-label i.fas.fa-users, .navbar-start a.navbar-item.router-link-exact-active .icon i.fas.fa-users {
  background: url('/static/img/imgh16.svg');
}

.navbar-brand img {
  width: 150px;
}

.navbar-brand {
  padding-left: 42px !important;
}

.left_column {
  position: relative;
  z-index: 9;
}

div#navMenu .navbar-end .navbar-dropdown.is-right {
  padding: 11px 25px;
}

div#navMenu .navbar-end .navbar-dropdown.is-right a {
  padding-left: 0px;
  padding-right: 0px;
  padding-top: 0px;
  padding-bottom: 15px;
}

div#navMenu .navbar-end .navbar-dropdown.is-right a:nth-last-child(1) {
  padding-bottom: 0px;
}

.left_column .back-blue:before {
  height: 100%;
  position: absolute;
  content: '';
  left: 0;
  width: 3px;
  background: #29357f;
}

.left_column .back-blue {
  border-left: 0px solid #1261a0 !important;
  position: relative;

}

.left_column .back-normal {
  border-left: 0px solid #30aae1 !important;
}

.left_column .menu-label i {
  width: 100% !important;
  background-position: 0px center !important;
  background-repeat: no-repeat !important;
}

.left_column .menu-label .icon.is-pulled-right i {
  position: absolute;
  right: 11px;
}


@media screen and (min-width: 1024px) {
  .column.is-2-widescreen {
    -webkit-box-flex: 0;
    -ms-flex: none;
    flex: none;
    width: 115px;
  }

  aside.left_column span.is-hidden-tablet-only {
    display: inline-block !important;
  }

  span.nav_item_li {
    /* margin-left: 8px; */
  }

  aside.left_column span.icon.is-left.is-large {
    height: 2.5rem;
    width: 1.6rem;
  }

  .left_column .menu-label .icon.is-pulled-right {
    position: absolute;
    top: 0px;
    right: -2px;
  }

  .left_column .menu-label .icon.is-pulled-right i.fa-plus:before {
    position: absolute;
    content: '';
    top: 50%;
    right: 0.65em;
    transform: translateY(-50%);
    background: url('/static/img/icon-add-filled.svg');
    width: 19px;
    height: 19px;
    background-repeat: no-repeat;
    background-position: center;

  }

  .left_column .menu-label .icon.is-pulled-right i.fa-minus:before {
    position: absolute;
    content: '';
    top: 50%;
    right: 0.9em;
    transform: translateY(-50%);
    background: url('/static/img/plus.svg');
    width: 19px;
    height: 19px;
    background-repeat: no-repeat;
    background-position: center;
  }

  ul.menu-list li a span.nav_item_li {
    padding-left: 12px !important;
  }

  .left_column .menu-list .router-link-active span.nav_item_li {
    padding-left: 9px !important;
  }

  .left_column .menu-label .icon.is-pulled-right i {
    position: absolute;
    right: 11px;
    top: 55%;
    transform: translateY(-50%);
  }

  .left_column .menu-label .icon.is-pulled-right i.fa-plus:before, .left_column .menu-label .icon.is-pulled-right i.fa-minus:before {
    right: 0px;
  }

  .padding-top-bottom-6.back-normal ul.menu-list li a span.nav_item_li {
    padding-left: 0px !important;
  }

  .padding-top-bottom-6.back-normal.parent-menu ul.menu-list li a span.nav_item_li {
    padding-left: 12px !important;
  }

}

@media screen and (max-width: 1200px) and (min-width: 768px) {
  .header_top_bar_review {
    display: none !important;
  }

  .navbar-item.has-dropdown .navbar-dropdown {
    width: 220px;
  }

  span.nav_item_li {
    /* margin-left: 8px; */
  }

  .menu > div:not(.parent-menu) {
    /* padding-left: 10px; */
  }

  span.profiler_name {
    width: 77%;
  }

  a.business-link-item.menu-label {
    padding-left: 5px;
  }

  a.business-link-item.menu-label span.bussiness_name {
    width: 80%;
    padding-left: 0.5rem;
  }

}

@media screen and (max-width: 1023px) {
  aside a, aside p {
    color: #58595b !important;
  }

  aside li.is-active a {
    color: #fff !important;
  }

  .custom-burger {
    color: #58595b !important;
    font-size: 11px;
    text-transform: capitalize;
    padding-top: 0px;
    padding-bottom: 0px;
  }

  .navbar-burger {
    background-color: transparent !important;
  }

  .custom-burger i {
    margin-left: 5px;
    position: relative;
    top: 1px;
  }

  .navbar {
    min-height: 2.7rem;
  }

  div#tabletRightMenu .navbar-item {
    font-size: 0.7rem;
  }

  div#tabletRightMenu {
    background: transparent;
  }

  #sideBar {
    margin-top: 30px;
  }
}

@media screen and (max-width: 1023px) and (min-width: 768px) {
  .admin_portal li.active_tab {
    display: block !important;
    border: 0px;
    width: 100%;
    background: transparent;
    font-size: 10px;
  }

  .admin_portal li {
    display: none !important;
  }
}

@media screen and (max-width: 991px) and (min-width: 768px) {
  .left_column .menu-label .fa-minus, .left_column .menu-label .fa-plus {
    display: none;
  }

  .left_column {
    width: 55px !important;
  }

  span.profiler_name, span.nav_item_li, ul.profiler_dropdown, .mobile-profile-switcher-menu-item:after {
    display: none;
  }

  .menu > div:not(.parent-menu) {
    padding: 0px;
    text-align: center;
  }

  aside.left_column .mobile-profile-switcher-menu-item .has-icons-left .icon {
    width: 100% !important;
    height: auto !important;
  }

  .mobile-profile-switcher-menu-item.padding-top-bottom-6 {
    float: left;
    width: 100%;
    clear: both;
  }

  .left_column .blue-back .router-link-active {
    color: #30aae1 !important;
  }

  .left_column nav.menu {
    margin-top: 14px;
  }

  .admin_portal {
    margin: 5px auto;
  }

  .left_column .menu-label .icon.is-pulled-right {
    display: none;
  }

  .left_column ul.menu-list li {
    clear: both;
  }

  .left_column ul.menu-list span.nav_item_li {
    display: block;
    padding: 0px 0px 0px 3px !important;
  }

  .left_column ul.menu-list span.icon.is-left.is-large {
    display: none;
  }

  aside.left_column.expand-div span.icon.is-left.is-large {
    height: 2.5rem;
    width: 1.5rem;
  }

  .left_column.expand-div .menu-label .fa-minus, .left_column.expand-div .menu-label .fa-plus {
    display: inline-block;
    position: absolute;
    top: 50%;
    right: 0.9em;
    -webkit-transform: translateY(-50%);
    transform: translateY(-50%);
  }

  .left_column.expand-div ul.menu-list span.icon.is-left.is-large {
    display: inline-block;
  }

  .expand-div {
    position: absolute;
    width: 174px !important;
    left: 0;
    transition: width 0.5s;
  }

  .left_column.expand-div .menu > div:not(.parent-menu) {
    padding: 5px 0px;
    padding-left: 10px;
    text-align: left;
  }

  .left_column {
    transition: width 0.5s;
  }

  .expand-div .admin_portal li {
    display: inline-block !important;
  }

  aside.left_column.expand-div .mobile-profile-switcher-menu-item .has-icons-left .icon {
    width: 30px !important;
    height: 30px !important;
    float: left;
  }

  .expand-div span.profiler_name, .expand-div span.nav_item_li, .expand-div ul.profiler_dropdown, .expand-div .mobile-profile-switcher-menu-item:after {
    display: inline-block;
  }

  .left_column.expand-div .menu-label .icon.is-pulled-right {
    display: block;
  }

  .left_column.expand-div ul.menu-list span.nav_item_li {
    padding-left: 0.4rem;
    display: inline-block;
  }

  .expand-div .admin_portal li.active_tab {
    background: #f2f2f2;
    font-size: 9px;
    width: 50%;
    border: solid 0.5px #d3d3d3;
  }

  .mobile-profile-switcher-menu-item.no-dropdown-icon:after {
    display: none !important;
  }

  .left_column ul.menu-list {
    display: none;
  }

  .left_column.expand-div ul.menu-list {
    display: block;
  }

  .custom-burger i {
    margin-left: 10px;
    position: relative;
    top: 0px;
  }

  .custom-burger i.fa-angle-down:before {
    border: solid 2px #7e7e7e;
    border-right: 0;
    border-top: 0;
    content: " ";
    display: block;
    height: 0.7em;
    pointer-events: none;
    width: 0.7em;
    right: 1.125em;
    z-index: 4;
    -webkit-transform: rotate(-45deg);
    transform: rotate(-45deg);
    -webkit-transform-origin: center;
    transform-origin: center;
  }

  div#tabletRightMenu {
    width: 220px;
    float: right;
    position: absolute;
    right: 0;
    background-color: #ffffff;
    border: 1px solid #dbdbdb;
    box-shadow: none !important;
  }

  div#tabletRightMenu .navbar-item.router-link-exact-active.router-link-active {
    background: #f0f1f2 !important;
    border-left: 2px solid #2faae1;
  }


}

@media screen and (min-width: 768px) {
  .mobile-profile-switcher-menu-item, .admin_portal.portal_mobile {
    display: none;
  }

  nav.navbar .mobile-profile-switcher-menu-item {
    display: none;
  }

  nav.menu .mobile-profile-switcher-menu-item {
    display: block;
  }

  .padding-top-bottom-6.back-normal ul.menu-list li a span.nav_item_li {
    padding-left: 0px !important;
  }

  .padding-top-bottom-6.back-normal.parent-menu ul.menu-list li a span.nav_item_li {
    padding-left: 12px !important;
  }
}

@media screen and (max-width: 767px) {
  div#navMenu, .navbar-start {
    background-color: #fff !important;
  }

  /* .navbar-burger span{    background-color: #2fabe1 !important; } */
  .navbar-brand a.navbar-item.is--brand {
    display: none;
  }

  .navbar-burger {
    float: left;
    margin: 0px;
    position: relative;
    z-index: 2;
  }

  .custom-burger {
    position: absolute;
    right: 0;
    height: 43.19px;
    display: block !important;
    z-index: 1;

  }

  .navbar-menu.is-active {
    display: block !important;
  }

  .left_column .router-link-active {
    color: #30aae1 !important;
  }

  .menu > div:not(.parent-menu) {
    /* padding-left: 10px; */
  }

  .mobile-profile-switcher-menu-item.padding-top-bottom-6 {
    padding-left: 20px !important;
  }

  button.button.navbar-burger.is-hidden-tablet, button.button.navbar-burger.is-hidden-desktop {
    /* left: 50px;top:0px; */
    top: 0px;
  }

  .mobile-profile-switcher-menu-item:hover ul.profiler_dropdown {
    display: none;
  }

  ul.profiler_dropdown.is-active {
    display: block !important;
  }

  nav.navbar.is-fixed-top-touch .mobile-profile-switcher-menu-item {
    padding: 0px !important;
    background-color: transparent !important;
  }

  .mobile-profile-switcher-menu-item p.menu-label {
    margin: 0px !important;
  }

  span.profiler_name, .mobile-profile-switcher-menu-item:after {
    display: none;
  }

  .mobile-profile-switcher-menu-item.padding-top-bottom-6 {
    position: absolute;
    top: 4px;
    z-index: 9999;
  }

  ul.profiler_dropdown {
    width: 100vh;
  }

  .navbar-burger span {
    width: 24px;
    height: 2px;
  }

  .navbar-burger span:nth-child(3) {
    top: calc(50% + 6px);
  }

  .navbar-burger span:nth-child(2) {
    top: calc(50% - 0px);
  }

  .navbar-burger span:nth-child(1) {
    top: calc(50% - 6px);
  }

  .admin_portal.portal_mobile ul {
  }

  .admin_portal {
    width: 100%;
    float: left;
    margin-bottom: 0px;
    margin-top: 0px;
  }

  .navbar-burger.is-active span:nth-child(1) {
    -webkit-transform: translateY(6px) rotate(45deg);
    transform: translateY(6px) rotate(45deg);
  }

  .navbar-burger.is-active span:nth-child(3) {
    -webkit-transform: translateY(-6px) rotate(-45deg);
    transform: translateY(-6px) rotate(-45deg);
  }

  .admin_portal ul li {
    float: left;
    line-height: 39px;
  }

  .navbar {
    min-height: 3.5rem;
  }

  .custom-burger {
    height: 56px;
  }

  button[data-target="navMenu"] {
    top: 5px;
  }

  .navbar-start {
    float: left;
    width: 100%;
    margin: 0px !important;
    min-height: 100vh;
  }

  .navbar-start .icon i {
    font-size: 14px;
  }

  .navbar-start span.nav_item_li, .navbar-start .navbar-item, .admin_portal ul li {
    font-size: 11px;
  }

  .navbar-start .navbar-item, .navbar-start.is-hidden-desktop.is-hidden-tablet > div, .navbar-start a.navbar-link.has-icons-right {
    padding: 0px !important;
  }

  .navbar-start.is-hidden-desktop.is-hidden-tablet > div[data-v-e792c8e8]:not(:last-child) {
    border-bottom: 0px !important;
  }

  .navbar-start span.icon.is-left.is-large {
    height: 2.5rem;
  }

  .navbar-start a.navbar-item {
    /*height: 40px;
    line-height: 36px;*/
    height: 33px;
    border-left: 3px solid #ffffff;
    padding-left: 20px !important;
  }

  .navbar-start a.navbar-item > img {
    vertical-align: middle !important;
  }

  .navbar-start a.navbar-item.router-link-exact-active.router-link-active {
    border-left: 3px solid #29357f;
    background: rgba(103,113,122,0.1) !important;
    padding-left: 17px !important;
    height: 40px;
    line-height: 36px;
    /* background-color: rgba(103, 113, 122, 0.1) !important; */
    /* border-left: 3px solid #30aae1 !important; */
  }

  /*.navbar-start a.navbar-item.router-link-exact-active.router-link-active > span {
    color: #30aae1 !important;
  }*/

  #navMenu .navbar-start .navbar-link::after {
    display: none;
  }

  #navMenu .navbar-start .navbar-link span.icon.is-small.is-right i {
    right: 15px;
    font-size: 11px;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
  }

  .navbar-start .navbar-dropdown, .navbar-start .navbar-item {
    background-color: transparent !important;
    color: #58595b !important;
  }

  .navbar-start .navbar-dropdown {
    margin: 0px !important;
    padding-left: 3.4rem;
  }

  .navbar-start .navbar-dropdown a {
    font-size: 11px !important;
  }

  .navbar-brand {
    min-height: 3.5rem !important;
    border-bottom: solid 1px #d3d3d3;
  }

  div#tabletRightMenu {
    min-height: 100vh;
  }

  header.hero.is-light nav.navbar.is-fixed-top-touch {
    border-bottom: 0px !important;
  }

  ul.profiler_dropdown {
    border-top: 0px;
    margin-top: 4px;
    min-height: 100vh;
  }

  a.business-link-item.menu-label.active span.bussiness_name {
    color: #30aae1 !important;
  }

  a.business-link-item.menu-label span.bussiness_name {
    font-size: 11px;
  }

  .custom-burger i.fas.fa-angle-down.is-active:before {
    content: "\f106";
  }

  .navbar-brand {
    padding-left: 0px !important;
  }

  div#navMenu .navbar-start div.is-hidden-touch {
    display: none !important;
  }
}

/* Slide Out Menu CSS Begins */
nav.menu .line-divider {
  margin-left: 0px;
  margin-right: 12px;
  border-top: 1px solid #1261a0;
}

.slide-out {
  top: 0;
  left: 100%;
  width: 195px;
  height: 100%;
  position: absolute;
  background: #ffffff;
  border-left: solid 1px rgba(88, 89, 91, 0.32);
  border-right: solid 1px rgba(88, 89, 91, 0.32);
}

.menu-items-section {
  padding: 12px 0;
  padding-left: 0 !important;
}

.slide-out .labeled-text {
  color: #58595b;
  opacity: 0.6;
  padding: 12px;
  font-size: 10px;
  font-weight: normal;
  font-family: Roboto;
  letter-spacing: 0.2px;
}

.slide-out .labeled-submenu {
  color: #1261a0;
  margin: 3% 0 0 0;
  font-size: 11px;
  font-weight: bold;
  font-family: Montserrat;
  letter-spacing: 0.2px;
}

.slide-out .labeled-submenu .column {
  color: #58595b;
  font-size: 11px;
  font-weight: normal;
  font-family: Roboto;
  letter-spacing: 0.2px;
}

.slide-out .labeled-submenu div {
  /* padding-top: 5px; */
}

.slide-out .labeled-submenu div {
  padding: 0.3rem 0.3rem 0.3rem 25px;
  border-left: 3px solid #ffffff;
}

.slide-out .labeled-submenu .selected-menu {
  /* padding-top: 12px; */
  border-left: 3px solid #29357f;
  color: #29357f;
  background-color: rgba(103, 113, 122, 0.1);
}

.side-menu-nav-items .nav_item_li {
  color: #29357f;
  font-size: 12px;
  font-weight: normal;
  font-family: Roboto;
  /* letter-spacing: 0.2px; */
}

.selected-menu {
  border-left: 3px solid #29357F !important;
  background-color: rgba(103, 113, 122, 0.1) !important;
}

.icon-as-image {
  margin-left: -4px;
}

.left_column .back-normal.selected-menu {
  border-left: 3px solid #1261a0 !important;
}

.slide-fade-enter-active, .slide-fade-leave-active {
  transition: transform 0.6s ease;
}

.slide-fade-enter, .slide-fade-leave-to {
  transform: translateX(-100%);
  transition: transform 0.2s ease-in;
}

/* Slide Out Menu CSS Ends */
.icon {
  justify-content: unset;
}


.new-modal > .modal-card {
  width: 400px;
}

.new-modal > .modal-background {
  background-color: rgba(10, 10, 10, 0.36);
}

.new-modal .modal-card-head {
  border-bottom: none;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
}

.new-modal .modal-card-foot {
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;
  border-top: none;
}

.new-modal .modal-card-title {
  font-family: Roboto;
  font-size: 16px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: #29357f;
}

.new-modal .modal-card-head, .new-modal .modal-card-foot {
  padding: 28px 25px;
  background-color: #ffffff;
}

.new-modal .modal-card-body {
  padding: 10px 10px 10px 25px;
}

.new-modal .modal-card-body > p {
  font-family: "Open Sans";
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #58595b;
}

.new-modal .modal-card-body > input {
  width: 354px;
  height: 35px;
  margin: 15px 2px 20px;
  border-radius: 17.5px;
  border: solid 1px #d0d0d0;
  background-color: #fff;
  font-family: "Open Sans";
  font-size: 12px;
  font-weight: 300;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  padding-left: 12px;
  color: #656769;
}


.new-modal .modal-card-body input::-webkit-input-placeholder {
  color: #666666;
}

.new-modal .modal-card-body input::-moz-placeholder {
  color: #666666;
}

.new-modal .modal-card-body input::-moz-placeholder {
  color: #666666;
}

.new-modal .modal-card-body input::-ms-input-placeholder {
  color: #666666;
}

.new-modal .modal-card-body > p.form-label {
  font-family: "Open Sans";
  font-size: 14px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #58595b;
}

.new-modal input[type="radio"]:checked {
  background-color: #29357f;
  border: 1px solid #29357f;
}

.new-modal input[type="radio"] {
  width: 17px;
  height: 17px;
  padding: 3.5px;
}

.new-modal .description, .new-modal .radio-label {
  font-family: "Open Sans";
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: #58595b;
}

.new-modal .description {
  font-weight: normal;
  font-size: 12px;
}

.new-modal .radio-label {
  font-weight: bold;
  font-size: 14px;
  padding-left: 16px;
}

.new-modal .form-label + .control {
  margin-top: 10px;
}

.new-modal .form-label + .control + .control {
  margin-top: 12px;
}

.new-modal .invite-btn {
  width: 196px;
  height: 41px;
  margin: 0 auto;
  cursor: pointer;
  border: none;
  margin-bottom: 20px;
  border-radius: 20.5px;
  background-color: #397ef5;
  font-family: "Open Sans";
  font-size: 14px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: #fff;
}

.new-modal .invite-btn:hover {
  color: #fff !important;
}

.new-modal button.delete {
  background-color: #29357f;
}

.new-modal .modal-card {
  border-radius: 10px;
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.21);
}

.new-modal .smaller > .modal-card-head {
  padding: 15px 20px 11px 20px;
}

.new-modal .smaller > .modal-card-head > .modal-card-title {
  font-size: 13px;
}

.new-modal .smaller > .modal-card-body {
  padding-left: 20px;
  padding-right: 20px;
  padding-top: 0;
}

.new-modal .smaller > .modal-card-body > .tabs {
  border: solid 1px #ececec;
  background-color: #f7f7f7;
}

.new-modal .smaller > .modal-card-body > .tabs > ul > li > a {
  color: #29357f;
  font-family: Roboto;
  font-size: 11px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
}

.new-modal .tabs ul {
  border-bottom: none;
}

.new-modal .tabs a {
  border: none;
  padding: 1.5em;
}

.new-modal .smaller > .modal-card-body > .tabs > ul > li {
  border-bottom: 3px solid #f7f7f7;
}

.new-modal .smaller > .modal-card-body > .tabs > ul > li.is-active {
  border-bottom: 3px solid #29357f;
}


.new-modal .section-header {
  font-family: "Open Sans";
  font-size: 12px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #29357f;
}

.new-modal .sub-section {
  font-size: 10px;
  font-weight: normal;
  color: #58595b;
}

.new-modal .ask-for-reviews {
  width: 200px;
  height: 35px;
  display: block;
  font-size: 11px;
  font-weight: 600;
  margin-left: auto;
  margin-right: auto;
}

.new-modal .input-ask-for-reviews {
  width: 200px;
  height: 35px;
  margin-left: auto;
  margin-right: auto;
  /* padding: 10px 50px 10px 51px; */
  text-align: center;
  border: 1px solid #d0d0d1;
  border-radius: 17.5px;
  font-size: 11px;
  display: block;
  font-weight: 300;
}

.mt45 {
  margin-top: 45px !important;
}

.mb15 {
  margin-bottom: 15px !important;
}

.mb20 {
  margin-bottom: 20px !important;
}

.mb10 {
  margin-bottom: 10px !important;
}

.tab-body {
  width: 100%;
}

.performance-card .level.is-mobile .level-item {
  margin-right: 0;
}

.mt30 {
  margin-top: 35px !important;
}

.mt10 {
  margin-top: 10px !important;
}

.mt15 {
  margin-top: 15px !important;
}

.mt25 {
  margin-top: 25px !important;
}

.level.is-mobile.mt30 .level-item {
  margin-right: 0;
}

.hr-line {
  width: 136px;
  height: 1px;
  background-color: #d0d0d0;
}

.hr-text > p {
  width: 15px;
  height: 15px;
  font-family: "Open Sans";
  font-size: 11px;
  font-weight: 300;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: #666666;
}

.copy-img {
  display: block;
  width: 26px;
  height: 28px;
  margin: 40px auto 20px auto;
}

.copy-btn {
  width: 200px;
  height: 35px;
  display: block;
  margin: 0 auto 60px auto;
  font-weight: 600;
}

.send-multiple-invites, .send-multiple-invites:visited, .send-multiple-invites:hover {
  text-decoration: underline;
  font-family: "Open Sans";
  font-size: 11px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: #397ef5;
}

.hr-line-full {
  width: 308px;
  height: 1px;
  margin: 18px auto 15px auto;
  background-color: #d0d0d0;
}

.footer-copy {
  width: 329px;
  height: auto;
  margin: 0 auto 10px auto;
  font-family: "Open Sans";
  font-size: 11px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: #666666;
}

.width236-center {
  display: block;
  width: 236px;
  height: auto;
  margin-left: auto;
  margin-right: auto;
  margin-bottom: 16px;
}

.width187-center {
  display: block;
  width: 187px;
  height: auto;
  margin-left: auto;
  margin-right: auto;
  margin-bottom: 16px;
}

</style>



// WEBPACK FOOTER //
// src/layouts/Master.vue